export const PAGE_SIZE = 50;
// Beyond this many rows in the DOM, ask the user to narrow filters instead.
export const MAX_ROWS_IN_DOM = 1000;
export const TAB_COUNT_REFRESH_MS = 60000;
export const NEW_ROWS_POLL_MS = 60000;
// Default window on the tab's first date-range column (0 = off).
export const DEFAULT_DATE_WINDOW_DAYS = 0;

export const STORAGE_KEYS = {
  tab: "viewReqV2.tab",
};

export const DATE_PRESETS: [string, number][] = [
  ["7 days", 7],
  ["30 days", 30],
  ["90 days", 90],
  ["12 months", 365],
];

// Columns rendered as actions/links rather than sortable data (same list as v1).
export const NON_SORTABLE_COLUMNS = ["printlabel", "nextstep", "flag", "resultfile"];

// Badge classes for the status column (same mapping as v1).
export const STATUS_BADGE_CLASSES: Record<string, string> = {
  "specimen collected": "badge-status-specimen-collected",
  processing: "badge-status-processing",
  "result available": "badge-status-result-available",
  complete: "badge-status-complete",
  completed: "badge-status-complete",
  deleted: "badge-status-deleted",
  validated: "badge-status-validated",
  "save for signature": "badge-status-waiting-for-Signature",
  "on hold": "badge-status-hold",
  "missing info": "badge-status-missing-info",
  "in transit": "badge-status-in-transit",
  canceled: "badge-status-canceled",
  approved: "badge-status-approved",
  pending: "badge-status-pending",
  rejected: "badge-status-rejected",
  shipped: "badge-status-shipped",
};

// v1 tab rules (tab ids from TabsConfiguration / TabColumnsV2):
// status changes, Zoho transfer, DOC edit, print & label print are hidden on these tabs…
export const BULK_ACTIONS_HIDDEN_TABS = [2, 3, 4, 5];
// …and the full row menu (View/Edit/Duplicate/History/Delete/Print/Insurance) shows on these;
// any other tab (e.g. Deleted) gets View + Restore.
export const FULL_ROW_MENU_TABS = [0, 1, 2, 3];

// Next steps that need date of collection + accession # first (v1 rule).
export const COLLECTION_NEXT_STEPS = ["checkin", "begin", "collect", "collected"];
